export const ViewFileProps = {
  /**文件类型,pdf,jpg,jpeg,png */
  type: {
    type: String,
  },
  /**文件路径 */
  url: {
    type: String,
  },
  /**文件流 */
  stream: {},
};
